<script lang="ts">
    
    import type { Map as Mapgl } from 'mapbox-gl';
    import { getContext, onDestroy, onMount } from "svelte";
    import type { Writable } from 'svelte/store';
    import type { RoutePath } from "../global";
    import { randomId } from '../Services';

    const map: Writable<Mapgl> = getContext('map');
    const dataId = randomId.create();

    let unsubscribeMap;
    let isDraw = false;

    export let path: RoutePath;
    export let color: string = '#000';
    export let width: number = 3;

    $: drawPath($map, path, color, width);

    onDestroy(() => {
        unsubscribeMap?.();
        clearPath($map);
    });

    function drawPath(map: Mapgl, path: RoutePath, color: string, width: number): void {
        
        clearPath(map);

        if (!map || !path) {
            return;
        }

        const pathGeojson: GeoJSON.Feature<GeoJSON.Geometry> = {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: path,
            },
            properties: {}
        };

        const pathLayer: mapboxgl.AnyLayer = {
            id: dataId,
            source: dataId,
            type: 'line',
            paint: {
                'line-color': color,
                'line-width': width
            }
        };

        map.addSource(dataId, {
            type: 'geojson',
            data: pathGeojson
        });

        map.addLayer(pathLayer);

        isDraw = true;

    }

    function clearPath(map: Mapgl) {
        if (!map || !isDraw) {
            return;
        }
        map.removeLayer(dataId);
        map.removeSource(dataId);
        isDraw = false;
    }

</script>